import React, { useEffect, useState, useContext } from 'react'
import { BarChart } from '@mui/x-charts/BarChart';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Box, Card, CardContent, CardHeader, Grid, MenuItem } from '@mui/material';
import { database } from '../../../firebaseConfig';
import { query, collection, getDocs, getDoc, doc, onSnapshot, where, orderBy } from 'firebase/firestore';
import dateFormat, { masks } from "dateformat";
import { AuthContext } from '../../../AuthProvider';
import { grey } from '@mui/material/colors';

function Statisitique() {
    const currentDate = new Date().getFullYear();
    const annees = [];
    for (let year = currentDate; year >= 2024; year--) {
        annees.push(year);
    }

    const { logOut, user } = useContext(AuthContext);
    const currentYear = dateFormat(new Date(), "yyyy")
    const [annee, setAnnee] = useState(currentYear)
    const [reservations, setReservations] = useState([])
    const [chus, setChus] = useState([])
    const [services, setServices] = useState([])
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        var q = query(collection(database, 'reservation'))
        if (user.chu_id != null) {
            q = query(collection(database, 'reservation'), where('chu_id', '==', user.chu_id))
        }
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const reservations = querySnapshot.docs.map(async (reservationDoc) => {
                const reservationData = reservationDoc.data()
                const chuId = reservationData.chu_id
                const serviceId = reservationData.service_id
                const chuDocRef = doc(database, 'chu', chuId);
                const chuDocSnapshot = await getDoc(chuDocRef);
                reservationData.nom_chu = chuDocSnapshot.data().nom_chu
                if (serviceId != null && serviceId != "") {
                    const serviceDocRef = doc(database, 'service', serviceId);
                    const serviceDocSnapshot = await getDoc(serviceDocRef);
                    reservationData.nom_service = serviceDocSnapshot.data().nom_service
                }
                return {
                    id: reservationDoc.id,
                    ...reservationData
                }
            })
            Promise.all(reservations).then((modifiedData) => {
                console.log(modifiedData)
                const dataProvisor = modifiedData.filter((a) => {
                    if (a.service_id != null && a.service_id != "" && a.date_rdv != null && a.date_rdv != "") {
                        return a
                    }
                })
                setReservations([dataProvisor])
                const dataChus = statistique_chus(dataProvisor)
                const dataServices = statistique_services(dataProvisor)
                setChus(dataChus)
                setServices(dataServices)
                console.log(dataChus)
            });
        })
        return () => unsubscribe();
    }, [annee]);
    const statistique_chus = (data) => {
        const aggregatedData = {};
        if (annee == '' || annee == null) {
            return []
        }
        data.forEach(item => {
            const year = item.date_rdv ? item.date_rdv.split('-')[0] : 'undefined';
            if (year != annee) return;
            if (!aggregatedData[item.nom_chu]) {
                aggregatedData[item.nom_chu] = { total: 0, total_status: 0 };
            }
            aggregatedData[item.nom_chu].total += 1;
            if (item.status) {
                aggregatedData[item.nom_chu].total_status += 1;
            }
        });
        const result = Object.keys(aggregatedData).map(nom => ({
            nom: nom,
            total: aggregatedData[nom].total,
            total_status: aggregatedData[nom].total_status
        }));
        return result
    }
    const statistique_services = (data) => {
        const aggregatedData = {};
        if (annee == '' || annee == null) {
            return []
        }
        data.forEach(item => {
            const year = item.date_rdv ? item.date_rdv.split('-')[0] : 'undefined';
            if (year != annee) return;
            if (!aggregatedData[item.nom_service]) {
                aggregatedData[item.nom_service] = { total: 0, total_status: 0 };
            }
            aggregatedData[item.nom_service].total += 1;
            if (item.status) {
                aggregatedData[item.nom_service].total_status += 1;
            }
        });
        const result = Object.keys(aggregatedData).map(nom => ({
            nom: nom,
            total: aggregatedData[nom].total,
            total_status: aggregatedData[nom].total_status
        }));
        return result
    }
    const listeChu = async () => {
        const res = []
        const q = query(collection(database, 'chu'), orderBy('nom_chu', 'asc'))
        const chu_refs = await getDocs(q);
        chu_refs.forEach(chu => {
            res.push({
                id: chu.id,
                ...chu.data()
            })
        })
        return res
    }
    const props = {
        height: 400,
        xAxis: [{ data: chus.map(item => item.nom), scaleType: 'band' }],
    };
    const props1 = {
        height: 400,
        xAxis: [{ data: services.map(item => item.nom), scaleType: 'band' }],
    };
    return (
        <div>
            <div>
                <TextField
                    id="outlined-select-currency"
                    select
                    label="Année"
                    defaultValue={annee}
                    onChange={(e) => {
                        setAnnee(e.target.value)
                    }}
                    value={annee}
                    sx={{ width: '20%' }}
                >
                    {annees.map((option) => (
                        <MenuItem key={option} value={option}>
                            {option}
                        </MenuItem>
                    ))}
                </TextField>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={12}>
                        <Box>
                            <Card>
                                <CardHeader title="Statistique par centre hospitalier" sx={{ bgcolor: grey[200] }} />
                                <CardContent>
                                    <BarChart
                                        {...props}
                                        series={[
                                            { data: chus.map(item => item.total), label: 'Reservation' },
                                            { data: chus.map(item => item.total_status), label: 'Confirmé' },
                                        ]}
                                    // margin={{ top: 10, bottom: 30, left: 40, right: 10 }}
                                    />
                                </CardContent>
                            </Card>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Box>
                            <Card>
                                <CardHeader title="Statistique par services" sx={{ bgcolor: grey[200] }} />
                                <CardContent>
                                    <BarChart
                                        {...props1}
                                        series={[
                                            { data: services.map(item => item.total), label: 'Reservation' },
                                            { data: services.map(item => item.total_status), label: 'Confirmé' },
                                        ]}
                                    // margin={{ top: 10, bottom: 30, left: 40, right: 10 }}
                                    />
                                </CardContent>
                            </Card>
                        </Box>
                    </Grid>
                </Grid>

            </div>
        </div>
    )
}

export default Statisitique